/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type OffboardingDetailDtoStatus = typeof OffboardingDetailDtoStatus[keyof typeof OffboardingDetailDtoStatus];


export const OffboardingDetailDtoStatus = {
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;
